exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.tofu-panel-component {\n  z-index: 2;\n  box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.3);\n  border-radius: 2px;\n  background: #FFFFFF;\n}\n.tofu-panel-component::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: -1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-119ddb7c!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tofu-panel/src/panel.vue
// module id = 456
// module chunks = 0